import type { ErrorComponentProps } from '@tanstack/react-router';
import { ErrorFallback } from '@repo/ui/components/molecules/error-fallback';
import { isAuthMeRequestError } from '@/api/auth/auth-query';
import { SessionCheckErrorPage } from '.';

/**
 * Errore di una rotta del backoffice: la lettura di `/me` non riuscita ha la
 * sua schermata con «Riprova» e «Torna al login»; il resto resta sulla pagina
 * condivisa con la webapp («Ricarica pagina»).
 */
export function BackofficeRouteError({ error }: ErrorComponentProps) {
  if (isAuthMeRequestError(error)) return <SessionCheckErrorPage />;
  return <ErrorFallback />;
}
